<div class="iframe-container" *ngIf="src">
  <iframe [src]="src" (load)="onMyFrameLoad()"></iframe>
</div>
